import { Tabs } from "antd";
import { Button } from "antd";
import { Modal } from "antd";
import React, { FC } from "react";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import EnhancementProcedureAyushman from "./EnhancementProcedureAyushman";
import DocumentUploadEnhancement from "../IHX/DocumentUploadEnhancement";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";
type EnhancementAyushmanProps = {
  addNewEnhancementModal: boolean;
  handleCancel: () => void;
  closeCreateEnhancementModal: any;
  handleSubmit: any;
  isFetchingPortalData: boolean;
  enhancementProcedure: any;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  patientDetails: IFetchAllDetails | null;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  handleSubmitEnhancementProcedure: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: CallableFunction;
  form: any;
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType?: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks?: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  enhancementReasonOptions: Array<{ label: string; value: string }>;
  uploadResult?: any;
  setUploadResult?: any;
};

const EnhancementAyushman: FC<EnhancementAyushmanProps> = (
  props
) => {
  return (
    <Modal
      visible={props?.addNewEnhancementModal}
      title="New Enhancement Case"
      centered
      width={1200}
      loading={props?.isFetchingPortalData}
      footer={[
        <Button key="back" onClick={props?.closeCreateEnhancementModal}>
          Cancel
        </Button>,

        // props?.activeKey === "2" ? (
        <Button
          type="primary"
          htmlType="submit"
          style={{
            border: "1px solid darkcyan",
            background: "darkcyan",
            fontSize: "14px",
            fontWeight: "400",
            color: "white",
          }}
          onClick={props?.handleSubmit}
        >
          SUBMIT
        </Button>,
        // ) : (
        //   <></>
        // ),
      ]}
      onCancel={props?.closeCreateEnhancementModal}
      //   onOk={handleSubmit}
      //   okButtonProps={{ loading: isSaving, disabled: isSaving }}
      //   cancelButtonProps={{ disabled: isSaving }}
      //   okText={isSaving ? "Saving..." : "Save"}
      style={{ top: 20 }}
      className="new-add-enhancement"
    >
      <EnhancementProcedureAyushman
        enhancementProcedure={props?.enhancementProcedure}
        formattedAccreditationOptions={props?.formattedAccreditationOptions}
        formattedTreatingDoctorsOptions={props?.formattedTreatingDoctorsOptions}
        formattedProcedureReferral={props?.formattedProcedureReferral}
        formattedProceduresOptions={props?.formattedProceduresOptions}
        handleGetProcedureAmount={props?.handleGetProcedureAmount}
        handleGetProcedureStrats={props?.handleGetProcedureStrats}
        patientDetails={props?.patientDetails}
        procedureStrats={props?.procedureStrats}
        handleDeleteProcedure={props?.handleDeleteProcedure}
        handleSubmitEnhancementProcedure={
          props?.handleSubmitEnhancementProcedure
        }
        isModalOpen={props?.isModalOpen}
        setIsModalOpen={props?.setIsModalOpen}
        handleOk={props?.handleOk}
        handleCancel={props?.handleCancel}
        form={props?.form}
        enhancementReasonOptions={props?.enhancementReasonOptions}
        handleFileChange={props?.handleFileChange}
        documentTypes={props?.documentTypes}
        uploadResult={props?.uploadResult}
        handleOpen={props?.handleOpen}
        setUploadResult={props?.setUploadResult}
      />
      <DocumentUploadEnhancement
        documentTypes={props?.documentTypes}
        documentUrls={props?.documentUrls}
        handleFileChange={props?.handleFileChange}
        handleOpen={props?.handleOpen}
      />
    </Modal>
  );
};

export default EnhancementAyushman;
